export var PerkSource;
(function (PerkSource) {
    PerkSource["AccessDevelopment"] = "ad";
    PerkSource["Venngo"] = "es";
})(PerkSource || (PerkSource = {}));
export function isVenngoPerk(perk) {
    return perk.source !== PerkSource.AccessDevelopment;
}
export function isADPerk(perk) {
    return perk.source === PerkSource.AccessDevelopment;
}
export const PERK_ACTIONS_SOURCE_MAP = {
    [PerkSource.Venngo]: 1,
    [PerkSource.AccessDevelopment]: 2,
};
;
